/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemDependencySchema } from './itemDependencySchema';

export const adaptivePlannerItemSchema = z.object({
  get dependencies() {
    return z.array(itemDependencySchema).nullish();
  },
  itemId: z.int(),
});
